import {t} from 'i18next'
import React from 'react'

export const getFormErrorMessage = (errors: { [x: string]: any }, name: string): JSX.Element => {
	return errors[name] && <small className="p-error">{errors[name].message}</small>
}


export const getEmailErrorMessage = (errors: { [x: string]: any }): JSX.Element => {


	if (errors['email']?.type === 'required') {
		return getFormErrorMessage(errors, 'email')
	}
	if (errors['email']?.type === 'pattern') {
		return <small className="p-error">{ t<string>('core.form.email_help')}</small>
	}
	if (errors['email']?.type === 'validate' ) {
		return <small className="p-error">{ t<string>('core.error.duplicated_email.message')}</small> 
	}
	return <></>

}


export const getRequiredFormMessage = (fieldName: string): string => {
	return `${t<string>(fieldName)} ${t<string>('core.form.required_text')}`
}